import Dragger from 'antd/es/upload/Dragger'
import React, { useState } from 'react'
import { InboxOutlined } from '@ant-design/icons';
import { message } from 'antd';
import type { UploadProps } from 'antd';
import HTTPClient from 'services/HTTPClient';
import Spinner from 'components/Spinner';

interface Props {
    onUploadComplete: () => void
    bookID?: number
}

export default function UploadBook({ onUploadComplete = () => { }, bookID }: Props) {

    const [isUploading, setisUploading] = useState(false)
    const [fileList, setFileList] = useState<any[]>([]);
    const [uploadProgress, setUploadProgress] = useState(0)

    const props: UploadProps = {
        fileList,
        name: 'file',
        multiple: false,
        async beforeUpload(file, FileList) {
            console.log("beforeUpload", file)
            var data = new FormData()
            data.append('file', file)
            if (bookID) {
                data.append("bookID", bookID.toString())
            }
            setFileList(FileList)
            setisUploading(true)
            try {
                // let response = await HTTPClient.get().postDataForJSONResult("/api/add-book", data)
                let response = await HTTPClient.get().uploadFileUsingAxios("/api/add-book", data, (progress) => {
                    console.log(progress)
                    setUploadProgress(parseInt(((progress.loaded / progress.total) * 100).toString()))
                })
                console.log("Upload response", response)
                message.success(`${file.name} file uploaded successfully.`);
                onUploadComplete()
            } catch (error) {
                message.error(`${file.name} file upload failed.`);
            }
            setisUploading(false)
            setFileList([])
            return false;
        },
        onChange(info) {
            console.log("OnChange", info)
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
    };

    return (
        <div>
            <h3 className='is-size-3 mb-5 between'>
                <strong>
                    Upload
                </strong>
            </h3>
            <Dragger {...props}>
                {isUploading
                    ? <div>
                        <Spinner className='mx-auto mt-2' />
                        {uploadProgress} %
                    </div>
                    : <>
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                        </p>
                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                        <p className="ant-upload-hint">
                            Supports single file only
                        </p>
                    </>
                }

            </Dragger>
        </div>
    )
}